import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "./translations";
import { setAutoLang } from "../lib/autoTranslate";

const LangCtx = createContext(null);
const RTL_LANGS = ["ar", "ur"];
const STORE_KEY = "wz_lang";

const resolve = (obj, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORE_KEY) || "ar");
  const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";

  useEffect(() => {
    const root = document.documentElement;
    root.lang = lang;
    root.dir = dir;
    root.classList.toggle("lang-ur", lang === "ur");
    const id = setTimeout(() => setAutoLang(lang), 0);
    return () => clearTimeout(id);
  }, [lang, dir]);

  const setLang = useCallback((l) => {
    localStorage.setItem(STORE_KEY, l);
    setLangState(l);
  }, []);

  const t = useCallback((key, vars) => {
    let val = resolve(translations[lang], key);
    if (val == null) val = resolve(translations.ar, key);
    if (val == null) return key;
    if (typeof val === "string" && vars) {
      Object.keys(vars).forEach((k) => {
        val = val.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]);
      });
    }
    return val;
  }, [lang]);

  return <LangCtx.Provider value={{ lang, setLang, dir, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangCtx);
  if (!ctx) return { lang: "ar", dir: "rtl", setLang: () => {}, t: (k) => k };
  return ctx;
};
